var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 11.5H16.3333C16.8375 11.5 17.25 11.0875 17.25 10.5833C17.25 10.0792 16.8375 9.66667 16.3333 9.66667H1.66667C1.1625 9.66667 0.75 10.0792 0.75 10.5833C0.75 11.0875 1.1625 11.5 1.66667 11.5ZM1.66667 6.91667H16.3333C16.8375 6.91667 17.25 6.50417 17.25 6C17.25 5.49583 16.8375 5.08333 16.3333 5.08333H1.66667C1.1625 5.08333 0.75 5.49583 0.75 6C0.75 6.50417 1.1625 6.91667 1.66667 6.91667ZM0.75 1.41667C0.75 1.92083 1.1625 2.33333 1.66667 2.33333H16.3333C16.8375 2.33333 17.25 1.92083 17.25 1.41667C17.25 0.9125 16.8375 0.5 16.3333 0.5H1.66667C1.1625 0.5 0.75 0.9125 0.75 1.41667Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.3a7f8d6a03cef9f5ecad44877067fcee.svg";
export { ForwardRef as ReactComponent };